import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  emoji?: string;
}
export function FAQItem({
  question,
  answer,
  emoji
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-[#1e2d42] border border-[#2C3E50] rounded-lg overflow-hidden hover:border-[#27AE60] transition-colors" data-id="element-305">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full p-4 flex items-center justify-between text-left hover:bg-[#1a2636] transition-colors" data-id="element-306">
        <div className="flex items-center gap-3" data-id="element-307">
          {emoji && <span className="text-2xl" data-id="element-308">{emoji}</span>}
          <h3 className="text-base md:text-lg font-bold text-white" data-id="element-309">
            {question}
          </h3>
        </div>
        <ChevronDownIcon className={`w-5 h-5 text-[#27AE60] flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-310" />
      </button>
      {isOpen && <div className="px-4 pb-4 pt-2 border-t border-[#2C3E50]" data-id="element-311">
          <p className="text-gray-300 leading-relaxed" data-id="element-312">{answer}</p>
        </div>}
    </div>;
}